<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em">Nina Pearce was a teacher for about 34 years, mainly in primary schools, which she enjoyed a great deal. She now has secondary progressive MS, which has affected her balance, so she can no longer cycle, but an adult tricycle has been her lifeline as, with the help of her husband Jonathan, she aims to do 100 miles each month.</p><br/>
<p style="text-indent:0em">She has always enjoyed science fiction as she finds it hard to believe that we are the only inhabited planet.</p><br/>
<p style="text-indent:0em">She has had five children. Though sadly, two died shortly after birth due to a genetic condition that at the time made their survival impossible.</p><br/>
<p style="text-indent:0em">She has four grandchildren with another expected in June. They are all a delight.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6e38b482